<template>
  <div class="fps-img-wrap">
    <div class="fps-img-box">
      <img
        ref="img"
        :data-src="src"
        class="fps-img-self"
        :class="{
          'opacity': loaded ? 1 : 0
        }"
        :style="{
          'border-radius': borderRadius,
        }"
        alt=""
        @load="imgLoaded"
        @error="imgErrored"
      />
    </div>
    <span
      v-show="!loaded"
      class="fps-img-place"
      :style="{
        'border-radius': borderRadius,
      }"
    />
  </div>
</template>

<script>

export default {
  props: {
    src: String,
    borderRadius: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  mounted() {
    const img = this.$refs['img']
    try {
      const observer = new IntersectionObserver(
        entries => {
          if (entries[0].intersectionRatio > 0 && !img.src) {
            img.src = img.dataset.src
          }
        }, {
          threshold: [0, 1]
        }
      )
      observer.observe(this.$el)
    } catch (e) {
      img.setAttribute('src', img.dataset.src)
    }
  },
  methods: {
    imgLoaded() {
      this.loaded = true
      this.$emit('load')
    },
    imgErrored() {
      const img = this.$refs['img']
      if (!img) return
      const ary = this.src.split('?d=')
      if (ary.length > 1) {
        img.src = ary[0]
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .fps-img {
    &-wrap {
      position: relative;
      width: 100%;
      height: 100%;
    }
    &-box, &-place {
      position: absolute;
      top: 0;
      left: 0;
    }
    &-box {
      @include flex();
      font-size: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    &-place {
      display: inline-block;
      width: 100%;
      height: 100%;
      background: #e8e8e8;
    }
    &-self {
      z-index: 1;
      opacity: 0;
      transition: opacity .4s;
      width: auto;
      height: 100%;
      &.opacity {
        opacity: 1;
      }
    }
  }
</style>
